<template>
  <v-autocomplete
    v-model="valueModel"
    :label="label"
    :parkCode="parkCode"
    :items="fieldOptions"
    :loading="loading"
    clearable
    @change="$emit('change')"
  />
</template>

<script>
  import client from '@/client'

  export default {
    props: ['value', 'label', 'parkCode'],
    data: () => ({
      loading: false,
      fieldOptions: []
    }),
    computed: {
      valueModel: {
        get () {
          return this.value
        },
        set (value) {
          this.$emit('input', value)
        }
      }
    },
    methods: {
      init () {
        this.loading = true
        client.getFieldList(this.parkCode)
          .then(results => {
            this.fieldOptions = results
          })
          .finally(() => {
            this.loading = false
          })
      }
    }
  }
</script>